<script setup lang="ts">
import BaseSelectBlog from '@/blog/infrastructure/components/BaseSelectBlog.vue';
import { usePostStore } from '@/blog/infrastructure/composition/usePostStore';
import { computed, ref } from 'vue';

interface Emits {
  (e: 'update:category', category: string): void;
}

interface Props {
  category: string;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { postState } = usePostStore();

const category = ref(props.category);

const defaultCategory = { label: 'All Blog Posts', value: '' };

const allCategories = computed(() => {
  if (postState.value.allPostLoading) {
    return [defaultCategory];
  }
  const categories = (postState.value.blogPage.categories ?? []).map(category => ({
    label: category.name,
    value: category.slug,
  }));
  categories.unshift(defaultCategory);

  return categories;
});

const selectedCategory = computed({
  get: () => {
    return (allCategories.value.find(opt => opt.value === category.value) || defaultCategory);
  },
  set: value => {
    category.value = value.value;
    emit('update:category', value.value);
  },
});
</script>

<template>
  <BaseSelectBlog
    v-model="selectedCategory"
    :options="allCategories"
  >
  </BaseSelectBlog>
</template>
